import React, { useState } from 'react';
// ANTD
import { Modal } from 'antd';
import { QuestionOutlined } from '@ant-design/icons';
// IMAGE
import tourstart_transfer from 'static/img/downloadGps/tourstart_transfer.png';
import cancel from 'static/img/cancel.png';

import withTranslations from 'app/components/HOGs/withTranslations';

const Question = ({ tr }) => {
  const [visible, setVisible] = useState(false);
  return (
    <>
      <QuestionOutlined onClick={() => setVisible(true)} />
      <Modal
        visible={visible}
        onCancel={() => setVisible(false)}
        mask
        footer={false}
        wrapClassName="gpsQuestionModal"
        width="50%"
        style={{ paddingBottom: 0, borderRadius: 4, minHeight: '50%' }}
        centered
        closeIcon={<img src={cancel} alt="cancel" />}
      >
        <div className="header">
          <img
            src={tourstart_transfer}
            alt="tourstart_transfer"
            style={{
              margin: 0,
              marginRight: 5,
              height: 'initial',
              width: 'initial',
            }}
          />
          {tr.Help}
        </div>
        <div className="mainContent">
          <p>
            <strong style={{ textDecoration: 'underline' }}>
              {`${tr['For transfer a route to your GPS device, follow one of these methods']}:`}
            </strong>
          </p>
          <p style={{ padding: '0px 10px', marginBottom: 5 }}>
            <strong>{`${tr['The first method']}:`}</strong>
          </p>
          <ol style={{ fontSize: 14 }}>
            <li>{tr['Open Tourstart Transfer']}</li>
            <li>{tr['Open the route which you want to transfer']}</li>
            <li>
              {
                tr[
                  'Connect the GPS to the computer and wait for Tourstart Transfer to detect it is connected'
                ]
              }
            </li>
            <li>
              {
                tr[
                  "When the button 'Transfer route to GPS' becomes active - press this button - and the route is transferred to the GPS"
                ]
              }
            </li>
          </ol>
          <p style={{ padding: '0px 10px', marginBottom: 5 }}>
            <strong>{tr['The second method']}</strong>
          </p>
          <ol style={{ fontSize: 14 }}>
            <li>
              {
                tr[
                  'Start Tourstart Transfer by clicking on the desired route you want to transfer to the GPS'
                ]
              }
            </li>
            <li>{tr['Open the route which you want to transfer']}</li>
            <li>
              {
                tr[
                  "When the button 'Transfer route to GPS' becomes active - press this button - and the route is transferred to the GPS"
                ]
              }
            </li>
          </ol>
          <p style={{ marginTop: 30, marginBottom: 5 }}>
            <strong style={{ textDecoration: 'underline' }}>
              {`${tr['The GPS is not recognized']}:`}
            </strong>
          </p>
          <ol style={{ fontSize: 14 }}>
            <li>{tr['Make sure the GPS is connected to the computer']}</li>
            <li>{tr['Wait for Tourstart Transfer to detect your GPS']}</li>
            <li>
              {
                tr[
                  'If your GPS is not detected, you can check in your file browser if the GPS is connected'
                ]
              }
            </li>
            <li>{tr['Write to info@tourstart_org for support']}</li>
          </ol>
          <p style={{ marginTop: 30, marginBottom: 5 }}>
            <strong style={{ textDecoration: 'underline' }}>
              {` ${'To add the GPS to the list of devices, follow these steps'}:`}
            </strong>
          </p>
          <ol style={{ fontSize: 14 }}>
            <li>{tr['Open Tourstart Transfer']}</li>
            <li>
              {
                tr[
                  'Connect the GPS to the computer and wait for the GPS to be detected'
                ]
              }
            </li>
            <li>
              {
                tr[
                  'A pop-up is shown in which you can select a GPS from the list of connected devices'
                ]
              }
            </li>
            <li>{tr["Click 'OK' to send information to Tourstart"]}</li>
          </ol>
        </div>
      </Modal>
    </>
  );
};

export default withTranslations(Question);
